import {useState, useEffect} from 'react';
import data from '../game_data.js'

function findGame(id){
    return data.find((game) => game.id == id);
}

export default function useGame(id){
    const [game, setGame] = useState(findGame(id));

    useEffect(() => {
        const foundGame = findGame(id);
        setGame(foundGame);
    }, [id])

    return game;
}